import React from "react";
import {Params, useParams} from "react-router-dom";

export function withRouter<Props>(Component: React.ComponentType<Props>) {
    return function(props: Props) {
        let params: Readonly<Params> = useParams()
        return <Component {...props} params={params} />
    }
}
